import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const LinkedinIcon = ({ className = '', color = 'currentColor' }) => {
    return (
        <svg
            className={`logo-24-24 ${className ? className : ''}`}
            fill='none'
            height='24'
            viewBox='0 0 23 24'
            width='23'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M19.5979 20.5943H16.1958V15.2595C16.1958 13.9818 16.1799 12.3526 14.4229 12.3526C12.65 12.3526 12.3785 13.7422 12.3785 15.1637V20.5943H8.97639V9.62134H12.2507V11.1227H12.2986C12.9694 9.9887 14.2153 9.3019 15.525 9.34982C18.975 9.34982 19.6139 11.6179 19.6139 14.5727L19.5979 20.5943ZM5.11111 8.11996C4.025 8.11996 3.13056 7.22551 3.13056 6.1394C3.13056 5.05329 4.025 4.15885 5.11111 4.15885C6.19722 4.15885 7.09167 5.05329 7.09167 6.1394C7.09167 7.22551 6.19722 8.11996 5.11111 8.11996ZM6.82014 20.5943H3.40208V9.62134H6.82014V20.5943ZM21.291 0.996344H1.69306C0.766668 0.980372 0 1.73107 0 2.65745V22.3352C0.0159722 23.2616 0.78264 24.0123 1.69306 23.9963H21.291C22.2174 24.0123 22.984 23.2616 23 22.3352V2.65745C22.984 1.73107 22.2174 0.980372 21.291 0.996344Z'
                fill={color}/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default LinkedinIcon;
